import { Box, Divider, Grid, Typography } from "@mui/material";
import { scope } from "../environments";
import CognitoSignIn from "./cognito/CognitoSignInForm";
import OICLoginButton from "./cognito/OICLoginButton";
import { AuthHeader } from "./components/Headers";
import { urlParams } from "../utils/urlParams";
import { getEnvironmentVariable } from "../global/environmentVariables";

const storedClientId = sessionStorage?.getItem("client_id");
const { client_id } = urlParams();
const AUTH_CLIENT_ID = getEnvironmentVariable("AUTH_CLIENT_ID") || "web-app";

export default function SignIn({ formState, updateFormState, setProcessing }) {
  const _scope = scope(client_id || storedClientId || AUTH_CLIENT_ID);
  const hasOIC = _scope?.filter((s) => s.type !== "cognito")?.length > 0;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <AuthHeader text="Sign In" />

      <Grid container spacing={2} sx={{ mt: 2 }}>
        {hasOIC && (
          <>
            {_scope
              ?.filter((s) => s.type !== "cognito")
              .map((oic_scope, index) => (
                <Grid key={`oic.${index}`} item xs={12}>
                  <OICLoginButton
                    oic_scope={oic_scope}
                    setProcessing={setProcessing}
                  />
                </Grid>
              ))}
            <Grid item xs={12} textAlign="center">
              <Grid container alignItems="center">
                <Grid item xs={5}>
                  <Divider />
                </Grid>
                <Grid item xs={2}>
                  <Typography>or</Typography>
                </Grid>
                <Grid item xs={5}>
                  <Divider />
                </Grid>
              </Grid>
            </Grid>
          </>
        )}

        <Grid item xs={12} textAlign="center">
          <Typography>Sign in with your username and password</Typography>
        </Grid>

        <Grid item xs={12}>
          <CognitoSignIn
            formState={formState}
            updateFormState={updateFormState}
            setProcessing={setProcessing}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
